import { Component, Input } from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';

export interface MenuItem {
  route: string;
  label: string;
}

export interface MenuSection {
  title: string;
  items: MenuItem[];
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [RouterLinkActive, RouterLink]
})
export class SidebarComponent {
  @Input() menuSections: MenuSection[] = [];

  /**
   *
   * @param index
   * @param item
   */
  trackByRoute(index: number, item: MenuItem): string {
    return item.route;
  }
}
